import { render, staticRenderFns } from "./nuestras-marcas.vue?vue&type=template&id=5b9f355e"
import script from "./nuestras-marcas.vue?vue&type=script&lang=js"
export * from "./nuestras-marcas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports